import styled from 'styled-components/macro'
import { ReactComponent as Logo } from './logo-triodos-bank.svg'
import { em } from '../../utils/styles'

const TriodosLogo = styled(Logo)`
  height: ${em(30)};
`

export default TriodosLogo
